"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.livWellNowPalette = void 0;
var palette_1 = require("../../shared/palette");
var palette = {
    primary: {
        '100': '#E5EAF4',
        '300': '#B2C2DE',
        '500': '#013592',
        '700': '#012A75',
        '900': '#012058',
    },
    secondary: {
        '100': '#E5EAF4',
        '300': '#B2C2DE',
        '500': '#013592',
        '700': '#012A75',
        '900': '#012058',
    },
    tertiary: {
        '100': '#E5EFFD',
        '300': '#B2CFFA',
        '500': '#0061EF',
        '700': '#004EBF',
        '900': '#003A8F',
    },
    neutrals: __assign(__assign({}, palette_1.commonNeutrals), { '100': '#EFEFEF', '300': '#DADADA', '500': '#B0B0B0', '700': '#4F4F4F', '900': '#363636' }),
    text: __assign(__assign({}, palette_1.commonTextColors), { disabled: '#8A8988', tertiary: '#37393B', secondary: '#202225', primary: '#013592', interactive: '#0061EF' }),
    accent01: {
        '100': '#F6FBFF',
        '300': '#E4F4FF',
        '500': '#A4DCFE',
        '700': '#83B0CB',
        '900': '#628498',
    },
    accent02: {
        '100': '#FFF8ED',
        '300': '#FFEBC9',
        '500': '#FFBE4C',
        '700': '#CC983D',
        '900': '#99722E',
    },
    accent03: {
        '100': '#EEEDF6',
        '300': '#CCC9E3',
        '500': '#554DA3',
        '700': '#443E82',
        '900': '#332E62',
    },
    accent04: {
        '100': '#F6E7F4',
        '300': '#E6B7DE',
        '500': '#AB1291',
        '700': '#890E74',
        '900': '#670B57',
    },
    success: __assign(__assign({}, palette_1.commonSuccess), { '700': '#027356' }),
    error: __assign({}, palette_1.commonError),
    warning: __assign({}, palette_1.commonWarning),
    info: __assign({}, palette_1.commonInfo),
    background: __assign(__assign(__assign({}, palette_1.commonBackgroundColors), palette_1.commonGradients), { light: '#DAF1FF', lightTwo: '#5EC0E9', lightThree: '#FFBE4C', dark: '#013592', darkTwo: '#AB1291', neutral: '#F7F7F7', occupationalmedicine: '#FFF5E5', virtualcare: '#CCCAE4', allergy: '#E6B8DE', primary: 'transparent', neutralGradient: 'linear-gradient(180deg, #F0F0F0 0%, #FAFAFA 70%)', lightGradient: 'linear-gradient(180deg, #85C9F2 0%, #A4DCFE 100%)', lightTwoGradient: 'linear-gradient(180deg, #42AEDB 0%, #5EC0E9 70%)', lightThreeGradient: 'linear-gradient(180deg, #EBA62F 0%, #FFBE4C 70%)', darkGradient: 'linear-gradient(165deg, #013592 4.91%, #0141B2 89.46%)', ODPHeroGradient: 'linear-gradient(97deg, rgba(0, 53, 146, 0.85) 33.86%, rgba(0, 53, 146, 0.00) 73.68%)', teamTagBrandColor: '#EB161E' }),
};
exports.livWellNowPalette = {
    primary: {
        lightest: palette.primary[100],
        light: palette.primary[300],
        main: palette.primary[500],
        dark: palette.primary[700],
        darkest: palette.primary[900],
    },
    secondary: {
        lightest: palette.secondary[100],
        light: palette.secondary[300],
        main: palette.secondary[500],
        dark: palette.secondary[700],
        darkest: palette.secondary[900],
    },
    tertiary: {
        lightest: palette.tertiary[100],
        light: palette.tertiary[300],
        main: palette.tertiary[500],
        dark: palette.tertiary[700],
        darkest: palette.tertiary[900],
    },
    neutrals: {
        white: palette.neutrals.white,
        neutral: palette.neutrals[100],
        primary: palette.neutrals[300],
        disabled: palette.neutrals[500],
        secondary: palette.neutrals[900],
        tertiary: palette.neutrals[700],
    },
    text: {
        primary: palette.text.primary,
        secondary: palette.text.secondary,
        tertiary: palette.text.tertiary,
        light: palette.text.light,
        disabled: palette.text.disabled,
        link: palette.text.interactive,
        interactive: palette.text.interactive,
    },
    accent01: {
        lightest: palette.accent01[100],
        light: palette.accent01[300],
        main: palette.accent01[500],
        dark: palette.accent01[700],
        darkest: palette.accent01[900],
    },
    accent02: {
        lightest: palette.accent02[100],
        light: palette.accent02[300],
        main: palette.accent02[500],
        dark: palette.accent02[700],
        darkest: palette.accent02[900],
    },
    accent03: {
        lightest: palette.accent03[100],
        light: palette.accent03[300],
        main: palette.accent03[500],
        dark: palette.accent03[700],
        darkest: palette.accent03[900],
    },
    accent04: {
        lightest: palette.accent04[100],
        light: palette.accent04[300],
        main: palette.accent04[500],
        dark: palette.accent04[700],
        darkest: palette.accent04[900],
    },
    success: {
        light: palette.success[300],
        main: palette.success[500],
        dark: palette.success[700],
    },
    error: {
        light: palette.error[300],
        main: palette.error[500],
        dark: palette.error[700],
    },
    warning: {
        light: palette.warning[300],
        main: palette.warning[500],
        dark: palette.warning[700],
    },
    info: {
        light: palette.info[300],
        main: palette.info[500],
        dark: palette.info[700],
    },
    backgrounds: __assign({}, palette.background),
};
